import React from "react";
import "./ourPattern.css";

export default function OurPattern() {
  return (
    <section id="OurPattern" className="ourPatternSection">
      <div className="patternHead">
        <h1>Our Pattern/Client</h1>
        <p>......</p>
      </div>
      <div className="patternList">
        <div className="logoCard">
        <img src="../images/logo/logo5.png" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo21.jpg" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo11.png" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo12.svg" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo13.png" alt="logo"></img>
        </div>
        <div className="logoCard">
        <img src="../images/logo/logo14.png" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo15.png" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo16.png" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo18.jpg" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo19.jpg" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo4.jpg" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo2.jpg" alt="logo"></img>
        </div>
        <div className="logoCard">
          <img src="../images/logo/logo3.jpg" alt="logo"></img>
        </div>
      </div>
    </section>
  );
}
